import { isEqual } from 'lodash';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

export const flattenWhereClause = (whereClause: WhereClause): WhereClause => {
  if (!whereClause.op?.params.length) {
    return whereClause;
  }

  if (whereClause.op.params.length === 1) {
    return whereClause.op.params[0];
  }

  const updatedParams = whereClause.op.params.map((param) => {
    const flattenedParam = flattenWhereClause(param);

    if (flattenedParam.op?.params && flattenedParam.op.params.length === 1) {
      return flattenedParam.op.params[0];
    }

    return flattenedParam;
  });

  return {
    ...whereClause,
    op: {
      ...whereClause.op,
      params: updatedParams.filter(
        (param) => !isEqual(param, EmptyWhereClause),
      ), // Remove empty where clause
    },
  };
};
